module.exports = __webpack_public_path__ + "static/img/increment04.e988506.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/increment04.png
// module id = hCIW
// module chunks = 0